import React, { Fragment } from 'react';

const Footer = (): JSX.Element => (
  <Fragment>
    &copy; {new Date().getFullYear()} <span>Hexact, Inc.</span>
  </Fragment>
);

export default Footer;
